import { Link } from 'react-router-dom';
import { categoryInfo } from '@/mocks/comics';

const categoryKeys = ['韩漫', '日漫', '国漫'] as const;

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            漫画分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            韩漫、日漫、国漫，总有一款适合你
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categoryKeys.map((key, idx) => {
            const info = categoryInfo[key];
            return (
              <Link
                key={key}
                to={`/category?type=${key}`}
                className="group relative overflow-hidden rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 p-6 md:p-8 cursor-pointer animate-fade-in-up"
                style={{ animationDelay: `${idx * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                    <i className={`${info.icon} text-2xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-300">
                      {info.name}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {info.description}
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-500 transition-all duration-300 flex-shrink-0">
                      <i className="ri-arrow-right-line text-foreground-400 group-hover:text-background-50 text-sm transition-colors duration-300"></i>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}